import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Typo } from 'uikit/content';

import styles from '../styles/uikitCardsCardPill.module.scss';

const CardMeta = ({ className = '', testId = '', text = '' }) => {
  const isLive = text === 'live';

  return (
    <div
      className={classnames(
        styles.element,
        {
          [styles.isLive]: isLive,
        },
        className,
      )}
      data-testid={testId}
    >
      {isLive && <span className={styles.pulse} />}
      <Typo element="span" variant="s01" modifier="uppercase">
        {isLive ? 'Live Now' : text}
      </Typo>
    </div>
  );
};

CardMeta.propTypes = {
  className: PropTypes.string,
  testId: PropTypes.string,
  text: PropTypes.string,
};

export default React.memo(CardMeta);
